import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import ProductList from '../components/UI/ProductList'

const BestSales = ({data}) => {
    return (
        <section>
            <Container>
                <Row>
                    <Col lg='12' className='text-center'>
                        <h2 className='section__title'>Best Sales</h2>
                    </Col>
                    <ProductList data={data}/>
                </Row>
            </Container>
        </section>
    )
}

export default BestSales